import { render, staticRenderFns } from "./archives-dialog.vue?vue&type=template&id=77012b5f&scoped=true"
import script from "./archives-dialog.vue?vue&type=script&lang=js"
export * from "./archives-dialog.vue?vue&type=script&lang=js"
import style0 from "./archives-dialog.vue?vue&type=style&index=0&id=77012b5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77012b5f",
  null
  
)

export default component.exports